export const addressOptions = {
  customer: 'customer',
  suggested: 'suggested',
}

export const addressOptionsRadioName = 'address-option'

export const drawerOptions = { showHeaderActions: false, useBlurForBackdrop: true }
